export default "__VITE_ASSET__Cr5g5NvI__"